import { Content, Placeholder } from '@kinesis/bungle';

// Renders when `/page/<key>` returns the `not-configured` arm — the
// disclosure exists but its definition hasn't been filled in (e.g. a
// freshly-created Community disclosure with no period yet). Editing
// affordances land in 2D.3.c; for now this is read-only signposting.
const DisclosureNotConfigured = () => (
  <Content
    alignX='center'
    textAlign='center'
    padding='medium'
    paddingMode='equal'
  >
    <Placeholder>This disclosure has not been configured yet.</Placeholder>
  </Content>
);

export { DisclosureNotConfigured };
